const { api } = require('../../../lib/bputils').default;

/* Engagement Stats */

export async function getEngagement(stationId, startDate, endDate) {
  const response = await api.get({
    path: `/stats/engagement/stations/${stationId}`,
    requestId: 'engagementStats',
    data: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });

  return response;
}

export async function getComparisonEngagement(stationId, startDate, endDate, stationState, comparisonMetric) {
  if (!comparisonMetric.metricApiPath) {
    return null;
  }

  const response = await api.get({
    path: `/stats/engagement/${comparisonMetric.metricApiPath}?filter=states&states=${stationState}`,
    requestId: `engagementStats_${comparisonMetric.metricApiPath}`,
    data: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      station_ids: [stationId],
    },
  });

  switch (comparisonMetric.metricApiName) {
    case 'industry':
    case 'brands':
      return response.stats;
    case 'prior-period':
    case 'nearby':
      return response[stationId];
    default:
      return response;
  }
}

/* Ratings Stats */
export async function getRatingCategories() {
  const response = await api.get({
    path: '/rating-categories',
    requestId: 'ratingCategories',
  });

  return response;
}

export async function getRatings(stationId, startDate, endDate) {
  const response = await api.get({
    path: `/stats/ratings/stations/${stationId}`,
    requestId: 'stationRatings',
    data: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });

  return response.categories.sort((a, b) => a.rating_category_id > b.rating_category_id);
}

export async function getComparisonRatings(stationId, categoryIds, startDate, endDate, stationState, comparisonMetric) {
  if (!comparisonMetric.metricApiPath) {
    return null;
  }
  const response = await api.get({
    path: `/stats/ratings/${comparisonMetric.metricApiPath}?filter=states&states=${stationState}`,
    requestId: `ratingsStats_${comparisonMetric.metricApiPath}`,
    data: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      station_ids: [stationId],
      rating_category_ids: categoryIds,
    },
  });

  let categoryRatings;
  switch (comparisonMetric.metricApiName) {
    case 'industry':
      categoryRatings = response.categories;
      break;
    case 'brands':
      categoryRatings = response.stats.categories;
      break;
    case 'prior-period':
    case 'nearby':
      categoryRatings = response[0].categories;
      break;
    default:
      categoryRatings = response.categories;
  }

  return categoryRatings;
}

export async function getRatingsCategoryScore(stationId) {
  const response = await api.get({
    path: `/stations/${stationId}/rating-scores`,
    requestId: 'getRatingsCategoryScore',
  });

  return response.rating_scores;
}

export async function getStationVisitsHourly(stationId, startDate, endDate) {
  const response = await api.get({
    path: `/stats/engagement/stations/${stationId}/hourly-visits`,
    requestId: 'stationHourlyVisits',
    data: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });
  return response;
}
